import React from 'react';
import { List } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../../../utils/queries'

import TitDer from '../../../components/funcionales/titder';

const Detalle = ({elemento, handleClickidLista}) => {
  let colorCelda='white'
  if(elemento.minimo>0 && elemento.minimo>=elemento.existencia){
    colorCelda = 'red'
  }
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrLubricante}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.existencia}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.minimo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrUnidad}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaAct?elemento.fechaAct.substr(0, 10):''}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.usuarioAct}</td>
    </tr>
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, i) => <Detalle elemento={elemento}
        handleClickidLista={handleClickidLista}
        key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

// const LabPruebaLab2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
class CarStockLub2 extends React.Component {
  state={argsBuscStock: {}, 
  argsQuery: `{"$unwind": "$inventario"},
  {$project: {_id: 1, descrLubricante: 1, 
      descrEmpresa: '$inventario.descrEmpresa', 
      existencia: '$inventario.existencia', 
      minimo: '$inventario.minimo',
      descrUnidad: '$inventario.descrUnidad', 
      usuarioAct: '$inventario.usuarioAct',
      fechaAct: '$inventario.fechaAct'}},
  {$sort: {descrLubricante: 1, descrEmpresa: 1}}`
  }

  componentDidMount(){
    this.props.allLubricanteRtes.refetch()
  }

  componentDidUpdate(prevProps){
    if(this.props.allLubricanteRtes.allLubricanteRtes!==prevProps.allLubricanteRtes){
      this.props.allLubricanteRtes.refetch()
    }
    if(this.props.argsBuscStock!==this.state.argsBuscStock){
      let argsBuscar=""
      if(this.props.argsBuscStock.descrLubricante){
        argsBuscar += `'descrLubricante': /${this.props.argsBuscStock.descrLubricante}/i`
      }
      if(this.props.argsBuscStock.descrEmpresa){
        if(argsBuscar){argsBuscar += `, `}
        argsBuscar += `'descrEmpresa': /${this.props.argsBuscStock.descrEmpresa}/i`
      }
      let argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
      this.props.allLubricanteRtes.refetch(argsBuscarPl)

      this.setState({argsBuscStock: this.props.argsBuscStock})
    }
  }

  render(){
    
    let list=[]
    if (this.props.allLubricanteRtes.allLubricanteRtes){
      list=this.props.allLubricanteRtes.allLubricanteRtes
    }
// console.log(list)
    return (
    <div>
      <List selection>
      <TitDer list={this.props.list} textBoton1="Stock de lubricantes" btnNuevo={"SI"} styles={this.props.styles} handleClick={this.props.handleClick} />

      <div>
        <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
          <thead className=''>
            <tr className=''>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Lubricante</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Empresa</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Existencia</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Mínimo</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Unidad</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha act.</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Usuario Act</th>
              </tr>
          </thead>
          <Lista list={list} handleClickidLista={this.props.handleClickidLista}/>
        </table>
        <p></p>
      </div>
      </List>
    </div>
  )
  }
};

export default compose(
  graphql(queries.query.allLubricanteRtes, {name:'allLubricanteRtes',
    options: (props) => {return {variables: {tipoqry: `[{"$unwind": "$inventario"},
    {$project: {_id: 1, descrLubricante: 1, 
        descrEmpresa: '$inventario.descrEmpresa', 
        existencia: '$inventario.existencia', 
        minimo: '$inventario.minimo',
        descrUnidad: '$inventario.descrUnidad', 
        usuarioAct: '$inventario.usuarioAct',
        fechaAct: '$inventario.fechaAct'}},
    {$sort: {descrLubricante: 1, descrEmpresa: 1}} 
  ]`}}}}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(CarStockLub2)